import React from "react";
import AdminAddNews from "../../Components/Admin/AdminAddNews";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddNewsPage = ()=>{
    return (
      <AdminAddNews />
    )
}

export default AdminAddNewsPage;